import {useTokenStore} from "@/src/store/use-token-store.ts";
import {useSignIn} from "@/src/composable/sign/use-sign-in.ts";
import type {NavigationGuardNext, RouteLocationNormalized} from "vue-router";

export const onCheckLogin = (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
) => {
  const $tokenStore = useTokenStore();
  const $signIn = useSignIn();

  if (!$tokenStore.accessToken) {
    $signIn.onSignIn();
    return;
  }

  next();
};
